import { cn } from '@/lib/utils'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
}

export function Input({ label, error, className, ...props }: InputProps) {
  return (
    <div className="w-full">
      {label && (
        <label className="mb-2 block font-condensed text-xs uppercase tracking-[0.15em] text-carbon/50">
          {label}
        </label>
      )}
      <input
        className={cn(
          'w-full border-b border-ink/20 bg-transparent px-0 py-3 text-carbon placeholder-ink/40 transition-colors focus:border-wd-orange focus:outline-none',
          error && 'border-wd-red',
          className
        )}
        {...props}
      />
      {error && <p className="mt-2 text-xs text-carbon">{error}</p>}
    </div>
  )
}
